import React from 'react';
import PropTypes from 'prop-types';

import { CarouselProvider } from '$contexts/carousel';
import Carousel, { CarouselNavigation, CarouselPagination, CarouselSlide } from '$partials/ui/carousel';
import ModuleLargeCard from './large-card';
import LargeCardCtaVariant from './large-card-cta-variant';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleLargeCarousel = ({
    title,
    items = {},
    parent
}) => {
    if (!items.cards) { return null;}
    if (parent === 'Home') {
        return (
            <div className='bg-white relative py-40 md:py-50'>
                <div className='layout-container'>
                    <ModuleLargeCard
                        parent={parent}
                        {...items.cards?.[0]} />
                </div>
            </div>
        );
    }
    if (items.cards.length === 1 ) {
        return (
            <LargeCardCtaVariant
                card={items.cards[0]}
                title={title} />
        );
    }
    return (
        <div className={`bg-white relative ${parent === 'Home' ? 'py-40 md:py-50' : parent === 'Detail' ? 'py-20 md:py-30' : 'py-40 md:py-60'}`}>
            <div className='layout-container'>

                <div className=' bg-white overflow-hidden w-screen max-w-screen left-1/2 relative -translate-x-1/2'>
                    <CarouselProvider swiperConfig={{
                        slidesPerView: 1,
                    }}>
                        <div className='z-10 flex relative layout-container'>
                            <div className={`w-full mb-40 md:mb-50 px-10 sm:px-5 md:px-10 flex flex-wrap items-center ${title ? 'justify-between' : 'justify-end'}`}>
                                {title && (
                                    <p className='type-style-2 md:type-style-3'>
                                        {title}
                                    </p>
                                )}
                                <CarouselNavigation className='w-full sm:w-auto mt-10 sm:mt-0'/>
                            </div>
                        </div>
                        <Carousel className='flex swiper-wrapper h-auto w-full relative'>
                            {items.cards.map((item, idx) => {
                                return (
                                    <CarouselSlide
                                        className='h-auto flex flex-wrap'
                                        index={idx}
                                        key={`${item.image?.id}-large-card-${idx}`}>
                                        <div className='layout-container w-full'>
                                            <ModuleLargeCard
                                                {...item}
                                                isCarousel={true} />
                                        </div>
                                    </CarouselSlide>
                                );
                            })}
                        </Carousel>
                        <div className='z-10 absolute w-full bottom-0 mb-30 md:mb-50'>
                            <div className='layout-container'>
                                <CarouselPagination
                                    className='flex px-40 sm:px-35 md:px-70'
                                    pages={items.cards}/>
                            </div>
                        </div>
                    </CarouselProvider>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

ModuleLargeCarousel.propTypes = {
    backgroundColor: PropTypes.string,
    items: PropTypes.shape({
        cards: PropTypes.array,
    }),
    title: PropTypes.string,
    parent: PropTypes.string,
};

export default ModuleLargeCarousel;
